import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  TextField,
  InputAdornment,
  TablePagination,
  Dialog,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Tooltip
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import CloseIcon from "@material-ui/icons/Close";
import DateRangeIcon from "@material-ui/icons/DateRange";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import MenuIcon from "@material-ui/icons/Menu";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import RestorePageIcon from "@material-ui/icons/RestorePage";
import ViewCompactIcon from "@material-ui/icons/ViewCompact";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import Menu from "@material-ui/core/Menu";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import { Assignment } from "@material-ui/icons";

/* ------------------------- Importaciones internas ------------------------- */
import { api } from "../../../services/api";
import { handleGenericUpdate } from "../../../core/utils/handleGeneric";
import { exportarExcel } from "../../../core/utils/excelGeneric";
import { renderEstadoTexto } from "../../../core/utils/constantes";
import { numeroATexto } from "../../../core/utils/formatNumATexto";
import { ADMINISTRACION, ADMINISTRADOR } from "../../../core/utils/roles.constants";
import { useAuth } from "../../../contexts/AuthContext";
import { generarOrdenCompraPDF } from "../../../components/PDF/OrdenCompraPDFGenerator";
import CrearOrden from "./adicionales/createOrden";
import ConfirmDialog from "../../../components/Dialogs/ConfirmDialog";
import BotonGenerico from "../../../components/Button/Button";

/* --------------------------------- Estilos -------------------------------- */
const useStyles = makeStyles((theme) => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  leftButtonContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
  },
  leftButton: {
    display: "flex",
    alignItems: "center",
    textTransform: "none",
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  buttonIcon: {
    marginRight: theme.spacing(1),
  },
  rightActionsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "space-between",
    },
  },
  searchField: {
    marginRight: theme.spacing(2),
    width: "200px",
    [theme.breakpoints.down("xs")]: {
      width: "50%",
      marginBottom: theme.spacing(1),
    },
  },
  iconButtonsContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      justifyContent: "flex-end",
      width: "100%",
    },
  },
  errorIcon: {
    color: "green",
    fontSize: "4rem",
    marginBottom: theme.spacing(2),
  },
  dialogTitle: {
    textAlign: "center",
  },
  dialogContent: {
    textAlign: "center",
  },
  dialogButtons: {
    justifyContent: "center",
  },
  greenButton: {
    color: "green",
    borderColor: "green",
    borderRadius: theme.shape.borderRadius,
    textTransform: "none",
  },
  menuIconButton: {
    color: theme.palette.primary.main,
  },
  menuItemIcon: {
    marginRight: theme.spacing(1),
  },
  greenIcon: {
    color: "green",
  },
  dateRangeFormContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  dateRangeFields: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& > *": {
      margin: theme.spacing(1),
      minWidth: "150px", // Asegura un ancho mínimo para alineación
    },
  },
  dateRangeButton: {
    marginTop: theme.spacing(2),
    alignSelf: "center", // Centrar el botón
  },
  greenBackg: {
    backgroundColor: "green",
    color: "white",
    "&:hover": {
      backgroundColor: "#388e3c",
    },
  },
  dialogContentWide: {
    minWidth: "500px", // Añade un ancho mínimo de 500px
    maxWidth: "1000px", // Ajusta a 700px para más espacio
    padding: theme.spacing(3), // Más espacio interno para mejor legibilidad
  },
  dialogTitleCols: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  // Para evitar el solapamiento del texto
  dialogTitleText: {
    marginRight: theme.spacing(3), // Separa el texto del ícono de cerrar
  },
}));

const Ordenes = () => {
  const classes = useStyles();

  // Usuario local
  const { getUser } = useAuth();
  const user = getUser();

  const [tipoOrden, setTipoOrden] = useState("");

  const [dataEvents, setDataEvents] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [showHiddenRecords, setShowHiddenRecords] = useState(false);
  const [showDateRangeForm, setShowDateRangeForm] = useState(false);

  const [openForm, setOpenForm] = useState(false);
  const [columnConfigOpen, setColumnConfigOpen] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState({
    IdEstado: true,
    Sector: false,
    NroOrdenDeCompra: true,
    NroRequisicion: true,
    tipoCompra: true,
    Concepto: false,
    Fecha_Creacion: true,
    Observaciones: true,
  });

  // ------------------ Estados de filtros ------------------
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");

  const [sectorFiltrado, setSectorFiltrado] = useState([]);

  const visibleRows = filteredEvents.filter(
    (row) => showHiddenRecords ? row.oculto : !row.oculto
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          ordenesDeCompraResponse,
          itemsRequisicionesResponse,
          sectoresResponse
        ] = await Promise.all([
          api.ordenesCompra.getAll(),
          api.itemsRequisiciones.getAll(),
          api.sectores.getAll(),
        ]);

        const itemsRequisicionesMap = itemsRequisicionesResponse.reduce((map, item) => {
          const id = item.idRequision;
          if (!map[id]) map[id] = [];
          map[id].push(item);
          return map;
        }, {});

        setSectorFiltrado(sectoresResponse.filter(s => s.oculto === 0));

        // IDs de requisiciones desde OC
        const requisicionIds = ordenesDeCompraResponse.map(oc => oc.IdRequisicion);

        // Obtener requisiciones por ID
        const requisiciones = await Promise.all(
          requisicionIds.map(id => api.requisiciones.getById(id))
        );

        // Formatear requisiciones para incluir Items
        const requisicionesFormateadas = requisiciones.map((req) => {
          const id = req.idRequision;

          const itemsReqList = itemsRequisicionesMap[id] || [];

          const itemsConDetalle = itemsReqList.map(itemReq => {

            const cantidad = parseFloat(itemReq.cantidad) || 0;
            const importeUnitario = parseFloat(itemReq.importeUnitario) || 0;
            const subtotal = importeUnitario * cantidad;

            return {
              ...itemReq,
              // nombreItem: item.nombre || '',
              nombreItem: itemReq.itemName || '',
              importeUnitario,
              cantidad,
              subtotal,
            };
          }).filter(Boolean);

          const totalImporte = itemsConDetalle.reduce((acc, item) => acc + item.subtotal, 0);

          return {
            ...req,
            ItemsRequisicion: itemsConDetalle,
            Importe: totalImporte,
          };
        });

        // Unir OCs con requisiciones formateadas
        const ordenesConRequisicion = ordenesDeCompraResponse.map((oc, index) => ({
          ...oc,
          Sector: sectoresResponse.find(s => s.IdSector === oc.IdSector)?.Nombre,
          requisicion: requisicionesFormateadas[index],
        })).filter((orden) => {
          const sectores = Array.isArray(user.sectores) && user.sectores.length > 0
            ? user.sectores.map(Number) : [Number(user.IdSector)];
          return user.es_admin === ADMINISTRADOR || user.es_admin === ADMINISTRACION || sectores.includes(Number(orden.IdSector));
        }).reverse();
        // })).filter((orden) => orden.IdSector === user.IdSector).reverse();

        setDataEvents(ordenesConRequisicion);
        setFilteredEvents(ordenesConRequisicion);

      } catch (error) {
        console.error("Error al cargar ordenes de compra y requisiciones:", error.message);
      }
    };

    fetchData();
  }, []);


  useEffect(() => {
    const visibleCount = filteredEvents.filter(
      (row) => showHiddenRecords ? row.oculto : !row.oculto
    ).length;

    if (page > 0 && page * rowsPerPage >= visibleCount) {
      setPage(Math.max(0, Math.ceil(visibleCount / rowsPerPage) - 1));
    }
  }, [filteredEvents, page, rowsPerPage, showHiddenRecords]);

  useEffect(() => {
    let temp = [...dataEvents];

    // Filtrar por oculto
    temp = temp.filter((row) => showHiddenRecords ? row.oculto : !row.oculto);

    // Filtrar por sector
    if (selectedSector) {
      temp = temp.filter((row) => row.IdSector === selectedSector);
    }

    // Filtrar por rango de fechas
    if (startDate) {
      temp = temp.filter((row) => new Date(row.Fecha_Creacion) >= new Date(startDate));
    }
    if (endDate) {
      temp = temp.filter((row) => new Date(row.Fecha_Creacion) <= new Date(endDate));
    }

    // Filtro de búsqueda
    if (searchText) {
      const text = searchText.toLowerCase();
      temp = temp.filter((event) =>
        Object.values(event).some(
          (value) =>
            value !== null && value !== undefined && String(value).toLowerCase().includes(text)
        )
      );
    }

    setFilteredEvents(temp);
    setPage(0);
  }, [dataEvents, searchText, selectedSector, selectedStatus, startDate, endDate, showHiddenRecords]);

  const handleSearchChange = (event) => {
    const text = event.target.value.toLowerCase();
    setSearchText(text);
    const filtered = dataEvents.filter((event) =>
      Object.values(event).some((value) =>
        value != null &&
        value.toString().toLowerCase().includes(text)
      )
    );
    setFilteredEvents(filtered);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleGenerarPDFOrdenCompra = async (row) => {
    try {
      // Buscar proveedor(es) asociados a esta OC
      const relacionesOCP = await api.ordenesDeCompraProveedor.getAll();
      const relacionesDeEstaOC = relacionesOCP.filter((r) => r.IdOC === row.IdOC);

      console.log("Relaciones de esta OC: ", relacionesDeEstaOC);
      let proveedoresData = [];
      if (relacionesDeEstaOC.length > 0) {
        const correos = await api.correoProveedores.getAll().catch(() => []);
        const proveedores = await Promise.all(
          relacionesDeEstaOC.map((relacion) =>
            api.proveedores.getById(relacion.IdProveedor)
          )
        );

        proveedoresData = proveedores.map((proveedor) => {
          const correosProveedor = correos
            .filter((c) => c.proveedor_id === proveedor.idProveedor)
            .map((c) => c.email)
            .filter(Boolean);

          return {
            razonSocial: proveedor.ApellidoyNombre ?? "Sin razón social",
            direccion: proveedor.Direccion ?? "Sin dirección",
            telefono: proveedor.Telefono ?? "Sin teléfono",
            email: correosProveedor.length > 0 ? correosProveedor.join(", ") : "Sin email",
            cuit: proveedor.cuit ?? "Sin CUIT",
            cbu: "",
            cuenta: "",
            banco: "",
            sucursal: proveedor.localidad ?? "Sin sucursal",
            chequeNombre: "",
          };
        });
      } else {
        proveedoresData = [{
          razonSocial: "Sin proveedor cargado",
          direccion: "Sin dirección",
          telefono: "Sin teléfono",
          email: "Sin email",
          cuit: "Sin CUIT",
          cbu: "",
          cuenta: "",
          banco: "",
          sucursal: "Sin sucursal",
          chequeNombre: "",
        }];
      }

      // Construir ítems desde la requisición
      const items = (row.requisicion?.ItemsRequisicion || []).map((item) => ({
        descripcion: item.descripcion || item.nombreItem || "Sin descripción",
        cantidad: item.cantidad ?? 1,
        precioUnitario: item.importeUnitario ?? 0,
      }));

      const importeTotal = row.requisicion?.Importe ?? 0;
      const entero = Math.floor(importeTotal);
      const centavos = Math.round((importeTotal - entero) * 100);
      const textoImporte = centavos > 0
        ? `${numeroATexto(entero)} con ${centavos.toString().padStart(2, "0")}/100`
        : numeroATexto(entero);

      await generarOrdenCompraPDF(
        {
          nroConfirmacion: row.NroOrdenDeCompra ?? "",
          proveedor: proveedoresData[0],
          proveedores: proveedoresData,
          nroOrdenPedido: row.requisicion?.NroRequisicion ?? "",
          fechaEmision: row.Fecha_Creacion
            ? row.Fecha_Creacion.split("T")[0].replace(/-/g, "/")
            : "",
          tipoFactura: "C",
          formaPago: { efectivo: false, cheque: false, transferencia: true },
          items,
          importeTotal,
          importeEnTexto: textoImporte,
        },
        { openInNewTab: true }
      );
    } catch (err) {
      console.error("Error al generar PDF de orden de compra:", err);
      alert("No se pudo generar el PDF.");
    }
  };

  const handleOpenDialog = (row, rowIndex) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleMenuOpen = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  const toggleHiddenRecords = () => {
    setShowHiddenRecords((prev) => !prev);
    handleMenuClose();
    setPage(0)
  };

  const exportToCSV = async () => {
    const columnas = [
      { key: 'IdEstado', label: 'Estado' },
      { key: 'NroOrdenDeCompra', label: 'Nro Orden' },
      { key: 'NroRequisicion', label: 'Nro Requisición' },
      { key: 'tipoOrdenDeCompra', label: 'Tipo' },
      { key: 'Fecha_Creacion', label: 'Fecha' },
      { key: 'Concepto', label: 'Concepto' },
      { key: 'Sector', label: 'Sector' },
      { key: 'Observaciones', label: 'Observaciones' },
    ];

    const formatearDato = (key, valor, row) => {
      switch (key) {
        case 'IdEstado':
          return valor ? renderEstadoTexto(valor) : 'Sin Estado';
        case 'NroOrdenDeCompra':
          return valor || 'No disponible';
        case 'NroRequisicion':
          return row.requisicion?.NroRequisicion || 'No disponible';
        case 'tipoOrdenDeCompra':
          return valor || 'Sin Tipo';
        case 'Fecha_Creacion':
          return valor || 'Fecha no disponible';
        case 'Concepto':
          return valor || 'Sin Concepto';
        case 'Observaciones':
          return valor?.trim() ? valor : 'Sin observación';
        default:
          return valor ?? '';
      }
    };

    // ✅ Generar objetos con claves de etiqueta legible
    const datosExcel = filteredEvents.map(row => {
      const fila = {};
      columnas.forEach(col => {
        const rawValue = col.key === 'NroRequisicion' ? row.requisicion?.NroRequisicion : row[col.key];
        fila[col.label] = formatearDato(col.key, rawValue, row);
      });
      return fila;
    });

    if (datosExcel.length > 0) {
      await exportarExcel('ordenes_de_compra', datosExcel);
    }

    handleMenuClose();
  };

  const renderEstadoIcon = (estado) => {
    const estadoColor = {
      1: "orange",  // Borrador
      2: "orange",  // Enviado a aprobar
      3: "green",   // Aprobado
      4: "red",     // Cancelado
      5: "blue",    // Completado (puedes cambiar el color)
    };

    const estadoTooltip = {
      1: "Pendiente de ejecución",
      2: "Pendiente recepción",
      3: "Cerrado",
      4: "Cancelado",
      5: "Completado",
    };

    const color = estadoColor[estado];
    const tooltipText = estadoTooltip[estado];
    if (!color || !tooltipText) return null;

    const icon = {
      1: Assignment,
      2: HourglassEmptyIcon,
      3: CheckCircleIcon,
      4: CancelIcon,
    };

    const Icon = icon[estado] || HourglassEmptyIcon;

    return (
      <Tooltip title={<span style={{ fontSize: "0.8rem" }}>{tooltipText}</span>} arrow>
        <Icon style={{ color }} />
      </Tooltip>
    );
  };

  const handleDateRangeClick = () => {
    setShowDateRangeForm(!showDateRangeForm);
  };

  const handleColumnConfigOpen = () => setColumnConfigOpen(true);
  const handleColumnConfigClose = () => setColumnConfigOpen(false);

  const handleColumnVisibilityChange = (column) => {
    setVisibleColumns((prev) => ({ ...prev, [column]: !prev[column] }));
  };

  const handleOpenForm = (row, index) => {
    // console.log("row: ", row);
    setOpenForm(true);
    setSelectedRow(row);
  };

  const handleCloseForm = (updatedOrder = null) => {
    setOpenForm(false);
    if (updatedOrder && updatedOrder.IdOC) {
      setDataEvents((prev) =>
        prev.map((row) =>
          row.IdOC === updatedOrder.IdOC ? { ...row, ...updatedOrder } : row
        )
      );
      setFilteredEvents((prev) =>
        prev.map((row) =>
          row.IdOC === updatedOrder.IdOC ? { ...row, ...updatedOrder } : row
        )
      );
    }
    setSelectedRow(null);
  };

  return (
    <div>
      <div className={classes.headerContainer}>
        <div className={classes.leftButtonContainer}>
          {/* <Button
            variant="contained"
            color="primary"
            className={classes.leftButton}
            onClick={handleOpenForm}
          >
            <AddCircleOutlineIcon className={classes.buttonIcon} />
            Nuevo
          </Button> */}
          <CrearOrden
            open={openForm}
            onClose={handleCloseForm}
            tipoOrden={tipoOrden}
            ordenDeCompra={selectedRow}
            sectorParams={sectorFiltrado}
          />
        </div>
        {showHiddenRecords && (
          <Typography variant="body1">
            Las ordenes de compra solo pueden ser editadas si fueron restauradas
          </Typography>
        )}
        <div className={classes.rightActionsContainer}>
          <TextField
            variant="outlined"
            size="small"
            placeholder="Buscar"
            value={searchText}
            onChange={handleSearchChange}
            className={classes.searchField}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <div className={classes.iconButtonsContainer}>
            <IconButton color="primary" onClick={handleDateRangeClick}>
              {showDateRangeForm ? <EventBusyIcon /> : <DateRangeIcon />}
            </IconButton>
            <IconButton
              className={classes.menuIconButton}
              onClick={handleMenuOpen}
            >
              <MenuIcon className={classes.greenIcon} />
            </IconButton>
            <Menu
              anchorEl={menuAnchorEl}
              keepMounted
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              {/* {user && user.es_admin === 1 && ( */}
              <MenuItem onClick={toggleHiddenRecords}>
                <VisibilityOffIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                {showHiddenRecords ? "Ver registros activos" : "Ver registros ocultos"}
              </MenuItem>
              {/* )} */}
              < MenuItem onClick={exportToCSV}>
                <RestorePageIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Exportar Registros
              </MenuItem>
              <MenuItem onClick={handleColumnConfigOpen}>
                <ViewCompactIcon
                  className={`${classes.menuItemIcon} ${classes.greenIcon}`}
                />
                Configurar Columnas
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>

      {
        showDateRangeForm && (
          <div className={classes.dateRangeFormContainer}>
            <div className={classes.dateRangeFields}>
              <InputLabel>Desde:</InputLabel>
              <TextField variant="outlined" type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              <InputLabel>Hasta:</InputLabel>
              <TextField variant="outlined" type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              <FormControl variant="outlined">
                <InputLabel>Sectores</InputLabel>
                <Select value={selectedSector} onChange={(e) => setSelectedSector(Number(e.target.value))}>
                  <MenuItem value="">Todos</MenuItem>
                  {sectorFiltrado.filter(s => s.oculto === 0).map((s) => <MenuItem key={s.IdSector} value={s.IdSector}>{s.Nombre}</MenuItem>)}
                </Select>
              </FormControl>
            </div>
            <BotonGenerico color="primary" onClick={() => { setStartDate(""); setEndDate(""); setSelectedSector(""); setSelectedStatus(""); }} text="Borrar filtros" />
          </div>
        )
      }

      <Dialog
        open={columnConfigOpen}
        onClose={handleColumnConfigClose}
        classes={{ paper: classes.dialogContentWide }}
        maxWidth="lg"
      >
        <DialogTitle className={classes.dialogTitleCols}>
          Configurar Columnas
          <IconButton
            onClick={handleColumnConfigClose}
            style={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {Object.keys(visibleColumns).map((column) => (
            <div key={column} style={{ display: "flex", alignItems: "center" }}>
              <Checkbox
                checked={visibleColumns[column]}
                onChange={() => handleColumnVisibilityChange(column)}
              />
              <Typography>{column}</Typography>
            </div>
          ))}
        </DialogContent>
      </Dialog>

      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              {visibleColumns.IdEstado && <TableCell align="center" style={{ width: "2%" }}>Estado</TableCell>}
              {visibleColumns.NroOrdenDeCompra && <TableCell align="center" style={{ width: "10%" }}>Nro Orden de Compra</TableCell>}
              {visibleColumns.NroRequisicion && <TableCell align="center" style={{ width: "10%" }}>Nro Requisicion</TableCell>}
              {visibleColumns.tipoCompra && <TableCell align="center" style={{ width: "15%" }}>Tipo de compra</TableCell>}
              {visibleColumns.Fecha_Creacion && (
                <TableCell align="center" style={{ width: "12%" }}>Fecha</TableCell>
              )}
              {visibleColumns.Concepto && (
                <TableCell align="center" style={{ width: "10%" }}>Concepto</TableCell>
              )}
              {visibleColumns.Sector && (
                <TableCell align="center" style={{ width: "8%" }}>Sector</TableCell>
              )}
              {visibleColumns.Observaciones
                && <TableCell align="center" style={{ width: "30%" }}>Observaciones</TableCell>}
              <TableCell align="center" style={{ width: "10%" }}>Opciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {visibleRows.length > 0 ? (
              visibleRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow key={`item-${index}`}>
                    {visibleColumns.IdEstado && (
                      <TableCell align="center" style={{ width: "2%" }}>{renderEstadoIcon(row.IdEstado)}</TableCell>
                    )}
                    {visibleColumns.NroOrdenDeCompra && (
                      <TableCell align="center" style={{ width: "10%" }}>{row.NroOrdenDeCompra}</TableCell>
                    )}
                    {visibleColumns.NroRequisicion && (
                      <TableCell align="center" style={{ width: "10%" }}>{row.requisicion.NroRequisicion}</TableCell>
                    )}
                    {visibleColumns.tipoCompra && (
                      <TableCell align="center" style={{ width: "15%" }}>{row.tipoOrdenDeCompra}</TableCell>
                    )}
                    {visibleColumns.Fecha_Creacion && (
                      <TableCell align="center" style={{ width: "12%" }}>{row.Fecha_Creacion}</TableCell>
                    )}
                    {visibleColumns.Concepto && (
                      <TableCell align="center" style={{ width: "10%" }}>{row.Concepto}</TableCell>
                    )}
                    {visibleColumns.Sector && (
                      <TableCell align="center" style={{ width: "8%" }}>{row.Sector}</TableCell>
                    )}
                    {visibleColumns.Observaciones && (
                      <TableCell align="center" style={{ width: "25%" }}>{row.Observaciones || "Sin observación"}</TableCell>
                    )}
                    <TableCell align="center" style={{ width: "15%" }}>
                      <Tooltip title={<span style={{ fontSize: "0.8rem" }}>Ver PDF</span>}>
                        <IconButton onClick={() => handleGenerarPDFOrdenCompra(row)}>
                          <PictureAsPdfIcon style={{ color: "#c0392b" }} />
                        </IconButton>
                      </Tooltip>
                      {!showHiddenRecords && (
                        <IconButton
                          onClick={() => {
                            handleOpenForm(row, index)
                            setTipoOrden(`Editando Orden de compra ${row.NroOrdenDeCompra}`);
                          }}
                        >
                          <SearchIcon color="primary" />
                        </IconButton>
                      )}
                      {!showHiddenRecords && (
                        <IconButton
                          onClick={() => handleOpenDialog(row, index)}
                          className={classes.greenButton}
                        >
                          <DeleteIcon color="secondary" />
                        </IconButton>
                      )}
                      {/* {showHiddenRecords && user && user.es_admin === 1 && ( */}
                      {showHiddenRecords && user && (
                        <IconButton
                          onClick={() => handleOpenDialog(row, index)}
                          className={classes.greenButton}
                        >
                          <RestorePageIcon color="secondary" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={Object.values(visibleColumns).filter(Boolean).length} align="center">
                  No hay Ordenes para mostrar
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={visibleRows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página"
      />

      <ConfirmDialog
        open={open}
        onClose={handleCloseDialog}
        onConfirm={() =>
          handleGenericUpdate({
            selectedItem: selectedRow,
            data: dataEvents,
            setData: (newData) => {
              setDataEvents(newData);
              setFilteredEvents(newData.filter(row => showHiddenRecords ? row.oculto : !row.oculto));
            },
            apiUpdateFunction: api.ordenesCompra.update,
            idField: "IdOC",
            updatePayload: showHiddenRecords ? { oculto: false } : { oculto: true },
            closeDialog: handleCloseDialog,
          })
        }
        title={showHiddenRecords ? "Recuperar Registro" : "Ocultar Registro"}
        description={showHiddenRecords ? "¿Está seguro de que quiere recuperar el registro?" : "¿Está seguro de que quiere ocultar el registro?"}
        confirmText={showHiddenRecords ? "Recuperar registro" : "Ocultar registro"}
        cancelText="Cancelar"
        icon={<ErrorOutlineIcon className={classes.errorIcon} />}
        classes={{
          dialogTitle: classes.dialogTitle,
          dialogContent: classes.dialogContent,
          dialogButtons: classes.dialogButtons,
          confirmButton: classes.greenButton,
          cancelButton: classes.greenButton,
          iconWrapper: classes.iconWrapper,
        }}
      />

    </div >
  );
};

export default Ordenes;
